import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import outer from './modules/outer'

Vue.use(Vuex)

const state = {
  // 用户的基本信息
  /**
   * // 头像
      avatar: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
      // 姓名
      name: '',
      // 权限
      role: '',
      // 电话
      mobile: '',
      // 性别
      gender: '',
      // 组织单位
      unit: '',
      // 邮箱
      email: ''
   */
  userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {
    // 用户id
    id: '',
    // 头像
    avatar: '',
    // 姓名
    name: '',
    // 权限
    role: '',
    // 电话
    mobile: '',
    // 性别
    gender: '',
    // 组织单位
    unit: '',
    // 邮箱
    email: ''
  },
  /*
    token
    role 角色：
      0： Unknowen ( 需要申请进入课题的用户 )
      10： 总负责人
      11:  项目联系人
      20： 课题负责人（主办单位负责人
      21： 课题联系人
      30： 参与单位负责人
      31： 单位联系人
      40： 单位成员
    docs 文档类别
      - k
      - v
    subjects 该项目下面的全部课题列表
      - id 课题ID
      - name 课题名称
    current_subject 用户所属课题 总负责人没有这个字段
      - id 当前用户所在课题ID
      - name 当前用户所在课题的名称
    current_company 成员所属单位 总负责人没有这个字段
      - id 所属单位ID
      - name 所属单位名称
    achievements 成果类型列表
   */
  // 登录后的基本信息
  baseInfo: localStorage.getItem('baseInfo') ? JSON.parse(localStorage.getItem('baseInfo')) : {
    // 角色
    role: '',
    // 是否是项目办的身份
    is_official: 0,
    // 文档类型下拉
    docs: [],
    // 课题组
    subjects: [],
    // 当前课题
    current_subject: {
      id: '',
      name: ''
    },
    // 当前单位
    current_company: {
      id: '',
      name: ''
    },
    // 成果类型
    achievements: []
  },
  // 项目信息
  projectInfo: localStorage.getItem('projectInfo') ? JSON.parse(localStorage.getItem('projectInfo')) : {
    name: ''
  }
}

const options = {
  state,
  mutations,
  actions,
  modules: {
    outer
  }
}

export default new Vuex.Store(options)



// WEBPACK FOOTER //
// ./src/store/index.js